import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ItemType } from "sprout-graphql";
import { useMemo } from "react";
import PostPageBreadcrumbsPost from "./PostPageBreadcrumbsPost";
import PostPageBreadcrumbsTodoList from "./PostPageBreadcrumbsTodoList";
const PostPageBreadcrumbs = (props)=>{
    const { breadcrumbsList: breadcrumbsListProp  } = props;
    const breadcrumbsList = useMemo(()=>{
        const reversed = [
            ...breadcrumbsListProp || []
        ].reverse();
        let cutToIndex = 0;
        for(; cutToIndex < reversed.length; cutToIndex++){
            const item = reversed[cutToIndex];
            if (item.__typename !== "Item" || item.type !== ItemType.Topic) break;
        }
        return reversed.slice(cutToIndex);
    }, [
        breadcrumbsListProp
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: breadcrumbsList.map((item)=>{
            const { type , nodeId , id , description  } = item;
            if (type === ItemType.Post) return /*#__PURE__*/ _jsx(PostPageBreadcrumbsPost, {
                post: item
            }, item.nodeId);
            if (type === ItemType.Checklist || type === ItemType.ChecklistItem) return /*#__PURE__*/ _jsx(PostPageBreadcrumbsTodoList, {
                type: type,
                itemId: id,
                description: description || "No description"
            }, nodeId);
            return null;
        })
    });
};
export default PostPageBreadcrumbs;
